import { CompareVFXConsumer } from './compare-vfx';
import { useSuperstarDetailContext } from './context';
import { RosterStarColorSelect } from '@wwe-portal/ui/features/roster/roster-star-color-select';

export const SelectStarColorConsumer = () => {
  const { selectedStarColor, changeStarColor } = useSuperstarDetailContext(
    (state) => ({
      selectedStarColor: state.currentStats.selectedStarColor,
      changeStarColor: state.changeStarColor,
    })
  );

  return (
    <div>
      <div className="mb-1 flex items-center gap-2">
        <span className="drop-shadow-text-2 text-sm font-bold uppercase italic text-[#00BFFF]">
          Select stars color
        </span>
      </div>
      <CompareVFXConsumer>
        <RosterStarColorSelect
          value={selectedStarColor}
          onChange={changeStarColor}
        />
      </CompareVFXConsumer>
    </div>
  );
};
